/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueInviteSummary } from './LeagueInviteSummary';
import {
    LeagueInviteSummaryFromJSON,
    LeagueInviteSummaryFromJSONTyped,
    LeagueInviteSummaryToJSON,
    LeagueInviteSummaryToJSONTyped,
} from './LeagueInviteSummary';

/**
 * 
 * @export
 * @interface ListAccountLeagueInvitesOutputBody
 */
export interface ListAccountLeagueInvitesOutputBody {
    /**
     * A URL to the JSON Schema for this object.
     * @type {string}
     * @memberof ListAccountLeagueInvitesOutputBody
     */
    readonly $schema?: string;
    /**
     * League invites for the account
     * @type {Array<LeagueInviteSummary>}
     * @memberof ListAccountLeagueInvitesOutputBody
     */
    invites: Array<LeagueInviteSummary> | null;
}

/**
 * Check if a given object implements the ListAccountLeagueInvitesOutputBody interface.
 */
export function instanceOfListAccountLeagueInvitesOutputBody(value: object): value is ListAccountLeagueInvitesOutputBody {
    if (!('invites' in value) || value['invites'] === undefined) return false;
    return true;
}

export function ListAccountLeagueInvitesOutputBodyFromJSON(json: any): ListAccountLeagueInvitesOutputBody {
    return ListAccountLeagueInvitesOutputBodyFromJSONTyped(json, false);
}

export function ListAccountLeagueInvitesOutputBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAccountLeagueInvitesOutputBody {
    if (json == null) {
        return json;
    }
    return {
        
        '$schema': json['$schema'] == null ? undefined : json['$schema'],
        'invites': (json['invites'] == null ? null : (json['invites'] as Array<any>).map(LeagueInviteSummaryFromJSON)),
    };
}

export function ListAccountLeagueInvitesOutputBodyToJSON(json: any): ListAccountLeagueInvitesOutputBody {
    return ListAccountLeagueInvitesOutputBodyToJSONTyped(json, false);
}

export function ListAccountLeagueInvitesOutputBodyToJSONTyped(value?: Omit<ListAccountLeagueInvitesOutputBody, '$schema'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invites': (value['invites'] == null ? null : (value['invites'] as Array<any>).map(LeagueInviteSummaryToJSON)),
    };
}

